import * as IdbKeyVal from "idb-keyval";
import Golfer, { LoftShots, LoftForFitting } from '../classes/Golfer';
import { GappingSequences } from '../data/GappingSequence';
import { PracticeShot, DefaultShotSelection } from '../classes/ShotSelection';
import * as TrackMan from '../classes/TrackMan';

export const enable = async () => {
    await IdbKeyVal.set("tutorial", true);
}

export const disable = async () => {
    await IdbKeyVal.del("tutorial");
}

export const isActive = async () => {
    let isActive = await IdbKeyVal.get('tutorial');
    return isActive !== undefined;
}

export const getGolfer = () => {
    let golfer = new Golfer();
    golfer.fullName = "Joe Smith";
    golfer.firstName = "Joe";
    golfer.lastName = "Smith";
    golfer.handicap = "11-15";
    golfer.courseConditions = "Firm";
    golfer.bunkerConditions = "Soft";
    golfer.confidence= "Medium";
    golfer.pwLoft = "47";
    golfer.highestLoft = "60"

    const gappingSequences = new GappingSequences();
//    golfer.recommendedLofts = gappingSequences.data.find(gs => gs.pwLoft == golfer.pwLoft && gs.highestLoft == golfer.highestLoft)!.gapping.split(' ') as Loft[];
    let shots52 = DefaultShotSelection.get("52");
    let shots56 = DefaultShotSelection.get("56");
    let shots60 = DefaultShotSelection.get("60");
    golfer.selectedLofts = [new LoftShots(0, "52", shots52!), new LoftShots(0, "56", shots56!), new LoftShots(0, "60", shots60!)]
    golfer.loftsForFitting = [new LoftForFitting(0, "52", "Full", [new PracticeShot('closed', TrackMan.convertDataToSimulatorData(JSON.parse(TrackMan.getSampleShot(0)) as TrackMan.Data)), new PracticeShot('closed', TrackMan.convertDataToSimulatorData(JSON.parse(TrackMan.getSampleShot(1)) as TrackMan.Data)), new PracticeShot('closed', TrackMan.convertDataToSimulatorData(JSON.parse(TrackMan.getSampleShot(2)) as TrackMan.Data))] as PracticeShot[])] as LoftForFitting[];

    return golfer;
}